<template>
    <div class="landing">
        <popup v-if="displayApplicationPopup" v-on:close="closeApplication" v-bind:ApplicationPopupData="ApplicationPopupData"/>

        <div class="video">
            <video ref="videoplayer" id="videoplayer" autoplay loop muted playsinline preload="auto">
                <source ref="videosource" src="./video/landing/video.mp4" type="video/mp4">
            </video>
            <div class="shade"></div>
            <div class="title">
                <h1 class="small">GA JIJ HET MAKEN IN DE</h1>
                <h1>ISOLATIEBRANCHE?</h1>
                <h2 class="eyebrow">ALTIJD WERK & GOED BETAALD</h2>
            </div>
        </div>
        
        <div class="guus">
            <div class="offset">
                <div class="content">
                    
                    <p>Speel de quiz, check je kansen voor isoleerder en win:</p>

                    <div class="prizes">
                        <img class="airpods" src="./images/landing/airpods.png"/>
                        <img class="airpods" src="./images/landing/airpods.png"/>
                        <img class="airpods" src="./images/landing/airpods.png"/>
                        <img class="airpods sets" src="./images/landing/3sets.png"/>
                    </div>
                </div>
            </div>
            <div class="placement">                
                <img @click.prevent="onPlayClick" src="./images/landing/guus2_v4.jpg" />
                <img class="flicker hand" @click.prevent="onPlayClick" src="./images/landing/guus_v4_handje.png" />
                <a href="#">
                    <img @click.prevent="onPlayClick" src="./images/landing/play.png" class="flicker"/>               
                </a>
            </div>
        </div>

        <div class="info" ref="info">
            <span class="more-info" @click.prevent="show = !show">Lees meer over werken in de isolatiebranche <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'chevron-circle-right']" size="lg"/></span>
            <transition name="slide" v-on:after-enter="afterEnterInfo">
                <div v-if="show" class="background">
                    <div class="info-content">
                        <span>
                            Als isoleerder zorg je ervoor dat gebouwen beter warmte vasthouden door bijvoorbeeld de spouwmuur te isoleren. De holle ruimte in de dubbele buitenmuur wordt dan gevuld met een isolerend materiaal bijvoorbeeld met glaswol.  Dit kan tot wel 40% procent besparing opleveren.<br/> 
                            <br/>
                            Het werk is afwisselend en je bent lekker buiten bezig. Het is belangrijk dat je goed kunt samenwerken en met bewoners kunt omgaan. Je ontvangt een prima salaris en er zijn volop mogelijkheden om door te groeien. <br/>
                            <br/> 
                            Voor 2030 moeten alle woningen in Nederland zijn geisoleerd. Dit betekent veel werk en mogelijkheden voor een mooie carrière in de isolatiebranche. En je levert bovendien een bijdrage aan een duurzame wereld.<br/>
                            <br/> 
                            Misschien is isoleerder worden daarom wel iets voor jou? Ben jij hiervoor geschikt? Speel de ik ga ’t maken - quiz en ontdek je talenten.
                        </span>
                        <br/>
                        <div class="start-button">
                            <h1 style="cursor: pointer" @click.prevent="onPlayClick"> 
                                Speel de quiz >
                            </h1>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="footer">
            <a href="#" @click.prevent="$router.push({ name: 'privacy'});">privacy</a> - 
            <a href="#" @click.prevent="$router.push({ name: 'disclaimer'});">disclaimer</a> - 
            <a href="#" @click.prevent="$router.push({ name: 'cookies'});">cookies</a>
        </div>
    </div>    
</template>

<script>
    import be from '../services/Backend';
    import Auth from '../services/Auth';

    import Velocity from 'velocity-animate';
    import PopUp from './modules/PopUp.vue';

    //components
    import TopContainer from './TopContainer.vue';

    export default {
        'components': {TopContainer, 'popup': PopUp},
        'data': () =>
        {
            return { 
                show: false,
                displayApplicationPopup: false,
                ApplicationPopupData: {
                    title: null,
                    text: null
                }
            }
        },

        'methods': {
            onPlayClick: function() {
                this.$router.push({ name: 'register'});
            },
            afterEnterInfo: function() {
                window.scrollTo(0, this.$refs.info.offsetTop);
            },
            closeApplication() {
                this.displayApplicationPopup = false;
            }
        },
        
        mounted(){
            if(this.$route.params.token != null)
            {
                be.anonymousAcceptApplication(this.$route.params.token).always( value => {
                console.log(value);
                if(value.status == 200)
                {
                    this.ApplicationPopupData.title = "Success!";
                    this.ApplicationPopupData.text = "De gebruiker heeft nu toegang tot de leeromgeving";
                }
                else
                {
                    this.ApplicationPopupData.title = "Uh oh!";
                    this.ApplicationPopupData.text = "Er is iets mis gegaan met het beschikbaar stellen van de leeromgeving. Het kan zijn dat de URL die u ingevuld heeft incorrect is.";
                }
                this.displayApplicationPopup = true});
            }
        }
    };
</script>
